import { Injectable } from '@angular/core';
import { I18nService } from '@core/services';
import { Store } from '@ngrx/store';
import { AUTH_RESET_PASSWORD, AUTH_UPDATE_FORM } from '@store/actions';
import { ComponentEnum, LanguajeEnum } from '@core/enums';
import { selectAuthLoading, selectLanguaje, selectStoreLoading } from '@store/selectors';
import { IAbstractPresenter, ILanguageObject } from '@core/interfaces';
import { IResetPasswordFormStrategyComponent } from './interfaces';
import { AuthModalComponentEnum } from '../../../enums';
import { Observable, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IResetPasswordFormStrategyPresenter } from './interfaces';
import { IAuthModalCallback } from '../../../interfaces';

@Injectable({ providedIn: 'root' })
export class ResetPasswordFormStrategyPresenter
	extends IAbstractPresenter<IResetPasswordFormStrategyComponent>
	implements IResetPasswordFormStrategyPresenter
{
	formGroup: FormGroup;
	loading$: Observable<boolean>;
	loadingStore$: Observable<boolean>;
	translations: ILanguageObject = {};
	languageEnum$: Observable<LanguajeEnum>;
	AuthModalComponentEnum = AuthModalComponentEnum;
	visitingCheckout: boolean = false;
	callback!: IAuthModalCallback;

	constructor(
		private store: Store,
		private i18nService: I18nService,
		private formBuilder: FormBuilder
	) {
		super();

		this.loading$ = this.store.select(selectAuthLoading);
		this.loadingStore$ = this.store.select(selectStoreLoading);
		this.languageEnum$ = this.store.select(selectLanguaje);

		this.formGroup = this.formBuilder.group({
			email: [
				null,
				[Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)],
			],
		});
	}

	dispatchActions(): void {}

	suscribeObservers(): void {
		this.languageEnum$.pipe(takeUntil(this.destroy$)).subscribe(lang => {
			const trans = this.i18nService.getTranslations(ComponentEnum.Auth, lang);
			this.translations = trans;
			this.view.translations = trans;
		});

		this.formGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
			this.store.dispatch(AUTH_UPDATE_FORM({ authForm: { ...value } }));
		});
	}

	getFieldErrorMessage(fieldName: string): string {
		const control = this.formGroup.get(fieldName);
		if (!control?.errors || !control.value) return '';

		if (fieldName === 'email') {
			if (control.errors['required']) return this.translations['emailRequired'] || 'Email is required';
			if (control.errors['email'] || control.errors['pattern']) return this.translations['emailInvalid'] || 'Invalid email format';
		}
		return '';
	}

	navigateTo(route: AuthModalComponentEnum): void {
		this.view.callback?.navigate(route);
	}

	onRequestResetPassword(): void {
		if (this.formGroup.valid) this.store.dispatch(AUTH_RESET_PASSWORD());
	}
}
